module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="form-group row">\n    <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (paperInput)) == null ? '' : __t) +
'</label>\n    <div class="col-sm-8">\n        <select name="paper" id="paper" class="DescartesUISelect form-control">\n            ';
_.each(papers,function(paper){;
__p += '\n            <option value="' +
((__t = (paper.value)) == null ? '' : __t) +
'">' +
((__t = (paper.text)) == null ? '' : __t) +
'</option>\n            ';
});;
__p += '\n        </select>\n    </div>\n</div>\n<div class="DescartesPanel card ">\n    <div class="card-header ' +
((__t = (panelCss)) == null ? '' : __t) +
'"><h3 class="DescartesUIPanelTitle card-title">' +
((__t = (marginsGroupInput)) == null ? '' : __t) +
'</h3></div>\n    <div class="card-body">\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (marginTopInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input type="number" step="any" min="0" required="true" class="DescartesUIInput form-control" name="marginTopInput" value="' +
((__t = (marginTop)) == null ? '' : __t) +
'"></input>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (marginBottomInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input type="number" step="any" min="0" required="true" class="DescartesUIInput form-control" name="marginBottomInput" value="' +
((__t = (marginBottom)) == null ? '' : __t) +
'"></input>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (marginLeftInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input type="number" step="any" min="0" required="true" class="DescartesUIInput form-control" name="marginLeftInput" value="' +
((__t = (marginLeft)) == null ? '' : __t) +
'"></input>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (marginRightInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input type="number" step="any" min="0" required="true" class="DescartesUIInput form-control" name="marginRightInput" value="' +
((__t = (marginRight)) == null ? '' : __t) +
'"></input>\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/PrinterSetup.ejs
// module id = 411
// module chunks = 0